import { ToastContent } from 'react-toastify/dist/types';
import { toast } from 'react-toastify';

export const showSuccess = (content: ToastContent = null) => {
  toast.success(content ?? 'Saved successfully!');
};

export const showError = (content: ToastContent = null) => toast.error(content ?? 'An error has occurred!');
